export default __webpack_public_path__ + "static/media/blog.000cc607.jpg";